module.exports = __webpack_public_path__ + "assets/images/slope-working-2/tablet.svg?v=53aa08b0";